export default "__VITE_ASSET__CTx3mMfR__"